import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {CssVarHelper} from './utils/css-var.helper';
import {AppDeviceService} from './app-device/app-device.service';
import {AuthService, VersionService} from '@fedelta-pos/data-client';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NotificationService} from './notification/notification.service';
import {first} from 'rxjs';
import {onEach} from './utils/observable-utils';
import {IconLibraryComponent} from './ui-elements/icon-library/icon-library.component';
import {LoadingSpinnerComponent} from './ui-elements/loading/loading-spinner/loading-spinner.component';
import {WatermarkComponent} from './ui-elements/watermark/watermark.component';
import {PageContainerComponent} from './navigation/page-container/page-container.component';
import {ConfigurationModel} from './configuration/configuration.model';

@Component({
    selector: "app-root",
    imports: [
        IconLibraryComponent,
        LoadingSpinnerComponent,
        PageContainerComponent,
        TranslateModule,
        WatermarkComponent
    ],
    templateUrl: "./app.component.html",
    host: {
        "(window:message)": "this.configurationModel.refreshPreview($event)"
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    private upgradeNotified: boolean = false;

    constructor() {
        const appDeviceService: AppDeviceService = inject(AppDeviceService);
        const versionService: VersionService = inject(VersionService);
        const translate: TranslateService = inject(TranslateService);
        const authService: AuthService = inject(AuthService);
        const notificationService: NotificationService = inject(NotificationService);

        const urlParams: URLSearchParams = new URLSearchParams(location.search);

        // Apply loading colors
        const cssVars: Record<string, string> = {};
        if (urlParams.has("bg")) {
            cssVars["--loadingBackground"] = "#" + urlParams.get("bg");
        }
        if (urlParams.has("fg")) {
            cssVars["--loadingForeground"] = "#" + urlParams.get("fg");
        }
        CssVarHelper.applyVars(document.documentElement, cssVars);

        translate.setFallbackLang("en");
        translate.use(translate.getBrowserLang());

        onEach(versionService.versionMismatch$.pipe(first()), () => {
            if (this.upgradeNotified) {
                return;
            }
            this.upgradeNotified = true;
            setTimeout(async () => {
                await notificationService.displayAlert("woa.error.version.incompatible", appDeviceService.isAvailable() ? "woa.error.version.auto-upgrade" : "woa.error.version.upgrade",
                    {}, false, appDeviceService.isAvailable() ? "woa.button.upgrade" : "woa.button.common.ok");
                if (appDeviceService.isAvailable()) {
                    return appDeviceService.reloadAppDevice();
                }
            }, 1000);
        });

        onEach(authService.compatibility$, async (compatible: boolean) => {
            if (!compatible) {
                if (this.upgradeNotified) {
                    return;
                }
                this.upgradeNotified = true;
                setTimeout(async () => {
                    await notificationService.displayAlert("woa.error.version.incompatible", appDeviceService.isAvailable() ? "woa.error.version.auto-upgrade" : "woa.error.version.upgrade",
                        {}, undefined, appDeviceService.isAvailable() ? "woa.button.upgrade" : "woa.button.common.ok");
                    if (appDeviceService.isAvailable()) {
                        return appDeviceService.reloadAppDevice();
                    }
                }, 1000);
            }
        });
    }
}
